import React from 'react'

export default function ProgressHeading() {
    return (
        <h5 className="fnt-smi-bld mt-3 candidate-form-heading">
            Progress Bar
        </h5>
    )
}
